import { useMediaQuery } from '@mui/system';
import { resolveColorScheme } from '@tix-ticketing/ui-theme';
import { useColorSchemeOverride, useThemeConfig } from 'lib/theme-config';

/**
 * The color scheme to render: the mode chosen in the DEV config selector when
 * set; otherwise the browser's light/dark setting when the tenant ships both a
 * light and a dark scheme, or else the tenant's one scheme.
 */
export function useColorScheme(): 'light' | 'dark' {
  const themeConfig = useThemeConfig();
  const [override] = useColorSchemeOverride();
  const prefersDark = useMediaQuery('(prefers-color-scheme: dark)');
  return override ?? resolveColorScheme(themeConfig, prefersDark);
}